import wixData from 'wix-data';
import wixSite from 'wix-site';
import {local} from 'wix-storage';
import {getPrsListXml} from 'backend/fetchData';
import {parsePrsXml, dateFormat, convertToSlug} from 'public/pressReleasesFunctions';
import { normalizeUrlToHttps } from 'public/utils.js'

const OFFSET = 0;
const LIMIT = 10;
const TITLE_STYLE = 'font: normal normal normal 16px/1.6em helveticaneuew01-45ligh,sans-serif; color: #000000;';

function populatePrItems(items){
	const structure = wixSite.getSiteStructure();
	const prefixes = structure.prefixes;
	
	$w("#prsRepeater").data = JSON.parse(items[0].xmlDump);

	$w("#prsRepeater").forEachItem( ($w, itemData, index) => {
		let itemTitle = itemData.title;
		let itemLink = prefixes[0].prefix+'/'+convertToSlug(itemTitle);
		$w("#prDate").text = dateFormat(itemData.date);
		$w("#prTitle").html = `<a style="${TITLE_STYLE}" target="_blank" href="${itemData.file}">${itemData.title}</a>`;
	});
	$w('#prsRepeater').show();
}

async function fetchPrsFromDb(count){
	let items = await wixData.query('prCache')
		.limit(count)
		.find()
		.then( (results) => {
			return results.items;
		})
		.catch( (err) => {
			let errorMsg = err;
		});

	return populatePrItems(items);
}

function loadPrs (specificLimit) {

	getPrsListXml(specificLimit, OFFSET, $w("#prCategories").value, $w("#prYears").value).then((xml) => {
		const structure = wixSite.getSiteStructure();
		const prefixes = structure.prefixes;
	
		if( parsePrsXml(xml, 0) !== null ){
			
			if( parsePrsXml(xml, 0).length === 50) {
				$w("#prsRepeater").data = parsePrsXml(xml, 0).slice(0,10);
				$w('#loadMoreButton').show();
			}else{
				$w("#prsRepeater").data = parsePrsXml(xml, 0);
			}			

			$w("#prsRepeater").forEachItem( ($w, itemData, index) => {
				let itemTitle = itemData.title;
				let itemLink = prefixes[0].prefix+'/'+convertToSlug(itemTitle);
				
				$w("#itemTitleGroup").link = itemData.file;
				$w("#prPdf").link = normalizeUrlToHttps(itemData.file);
				$w("#prTitle").html = `<a style="${TITLE_STYLE}" target="_blank" href="${itemData.file}">${itemData.title}</a>`;
				$w("#prDate").text = dateFormat(itemData.date);
			});
			
			$w('#messageNoResults').hide();
			$w('#prsRepeater').show();
			$w('#prsRepeater').expand();
		}else{
			$w('#messageNoResults').show();
			$w('#prsRepeater').collapse();
		}
	})
	.catch( (err) => {
		let errorMsg = err;
		console.log('errorMsg', errorMsg);
		fetchPrsFromDb(10);
	});
}

async function popuplatePrRepeater(repeaterData) {
	const structure = wixSite.getSiteStructure();
	const prefixes = structure.prefixes;
	$w("#prsRepeater").data = repeaterData;

	$w("#prsRepeater").forEachItem( ($w, itemData, index) => {
		let itemTitle = itemData.title;
		$w("#prDate").text = dateFormat(itemData.date);				
		$w("#prPdf").link = normalizeUrlToHttps(itemData.file);
		let itemLink = prefixes[0].prefix+'/'+convertToSlug(itemTitle);
		$w("#prTitle").html = `<a style="${TITLE_STYLE}" target="_blank" href="${itemData.file}">${itemTitle}</a>`;
	});
}

$w.onReady( function() {
	// let structure = wixSite.getSiteStructure();
	// let prefixes = structure.prefixes;
	let year = $w("#prYears").value;

	loadPrs(10);

	/* Load More PRs */
	let calculatedOffset = 0;
});

export function prCategories_change(event, $w) {
	$w('#loadMoreButton').hide();
	loadPrs(50);
}

export function prYears_change(event, $w) {
	$w('#loadMoreButton').hide();
	loadPrs(50);
}

let calculatedOffset = 0;

export function loadMoreButton_click(event, $w) {
	let structure = wixSite.getSiteStructure();
	let prefixes = structure.prefixes;
	let year = $w("#prYears").value;
	
	calculatedOffset = calculatedOffset+LIMIT;
	var currentData = $w("#prsRepeater").data;

	getPrsListXml(LIMIT, calculatedOffset, $w("#prCategories").value, year).then((xml) => {
		$w("#prsRepeater").data = parsePrsXml(xml);
		var newData = $w("#prsRepeater").data;
		var newObj = currentData.concat(newData);
		newObj.forEach((item, index)=>{
			item._id = item._id.toString();
		});
		
		$w("#prsRepeater").data = newObj;
		
		$w("#prsRepeater").forEachItem( ($w, itemData, index) => {
			let itemTitle = itemData.title;
			$w("#prDate").text = dateFormat(itemData.date);				
			$w("#prPdf").link = normalizeUrlToHttps(itemData.file);
			let itemLink = prefixes[0].prefix+'/'+convertToSlug(itemTitle);
			$w("#prTitle").html = `<a style="${TITLE_STYLE}" target="_blank" href="${itemData.file}">${itemTitle}</a>`;
		});
	}).then( ()=> {
		$w('#loadMoreButton').label = 'LOAD MORE';
	})
	.catch ( (err)=>{
		console.log('err', err);
		$w('#loadMoreButton').hide();
	});
}

export function text23_click(event, $w) {
	local.setItem('selectedPrId', '122506');

	let value = local.getItem('selectedPrId'); // "value"
	console.log('value', value);
}